import React from 'react';
import { SvgIcon } from '@mui/material';

export default function ClockIcon({ sx, ...props }) {
  const firstColor = props.color || '#4520AB';
  const secondColor = '#ffffff';
  return (
    <SvgIcon
      viewBox="0 0 28 28"
      sx={{ width: 28, height: 28, ...sx }}
      {...props}
    >
      <rect width="28" height="28" rx="8" fill={firstColor} />
      <path
        d="M12.832 7V16.3333H19.832"
        stroke={secondColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
}
